import { _values, exists, scrub } from '@nu-art/ts-common';
export const SearchAddOn_PathwayStatus = {
    key: 'pathway-status',
    methodName: 'getPathwayStatus',
    label: 'Pathway Status',
    group: 'Pathway',
    isActive: (param) => {
        const scrubbed = scrub(param, { emptyObjects: true });
        return exists(scrubbed) && !!_values(scrubbed).length;
    },
    resultFilter: (param, result) => {
        const _res = result.filterResults['pathway-status'].value;
        return {
            pass: exists(_res) && (!exists(param?.isArchived) || param.isArchived === _res.isArchived)
                && (!exists(param?.isUnderConstruction) || param.isUnderConstruction === _res.isUnderConstruction)
                && (!exists(param.types) || !!param.types[_res.type]),
        };
    }
};
//# sourceMappingURL=types.js.map